import React, { useState, useEffect } from "react";
import UploadForm from "./components/Uploadform";
import ThemeToggle from "./components/ThemeToggle";
import "./index.css";

export default function App() {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    document.body.style.backgroundColor = darkMode
      ? "var(--bg-dark)"
      : "var(--bg-light)";
    document.body.style.color = darkMode ? "var(--text-dark)" : "var(--text-light)";
  }, [darkMode]);

  return (
    <div
      className="container"
      style={{
        background: darkMode ? "var(--card-dark)" : "var(--card-light)",
        color: darkMode ? "var(--text-dark)" : "var(--text-light)",
      }}
    >
      <ThemeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
      <h1 style={{ textAlign: "center" }}>🧬 Chet Jeppiti AML Risk Assessment</h1>
      <p style={{ textAlign: "center", opacity: 0.8 }}>
        AI-powered probability analysis for detecting Acute Myeloid Leukemia
      </p>
      <UploadForm darkMode={darkMode} />
    </div>
  );
}
